import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

export const RenameFolderDialog = ({ folder, onClose, onRenamed }) => {
  const [name, setName] = useState("");
  useEffect(() => {
    if (folder) setName(folder === "Unassigned" ? "" : folder);
  }, [folder]);

  const rename = async () => {
    if (!name.trim()) return toast.error("Enter the new folder name");
    try {
      const { data } = await api.post("/clients/rename", { old: folder, new: name.trim() });
      toast.success(`Renamed - ${data.projects_moved} project(s) moved to "${name.trim()}"`);
      onClose();
      onRenamed(folder, name.trim());
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <Dialog open={!!folder} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="rename-folder-dialog">
        <DialogHeader><DialogTitle className="font-display">Rename folder - {folder}</DialogTitle></DialogHeader>
        <div>
          <Label>New folder name</Label>
          <Input value={name} onChange={(e) => setName(e.target.value)} className="mt-1" data-testid="rename-folder-input" autoFocus />
          <p className="text-[11px] text-muted-foreground mt-1.5">All projects in this folder move to the new name. If the name already exists, the folders are merged.</p>
        </div>
        <DialogFooter><Button onClick={rename} className="w-full" data-testid="rename-folder-save">Rename folder</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
